module.exports = __webpack_public_path__ + "static/media/solar-roof.a1f0b9e1.jpg";